import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PackageItem from "./PackageItem";
import auth from '../../auth';
import register from '../../Actions/register';
import paymentTransaction from '../../Actions/paymentTransaction';
const { saveNewTransaction, saveUserNewTransaction } = paymentTransaction.actions;
const { selectPackageToBuy } = register.actions;

class PackageItemContainer extends Component {
    constructor(props) {
        super(props);
        this.selectPackage = this.selectPackage.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    render() {
        let { packages } = this.props;
        let commonPackage = packages.filter(packageItem => packageItem.rfcLimit !== "Ilimitados" && packageItem.isExtra === false);        
        return (
            <div className="main-container buy-license-main-container">
                <div className="package-wrapper">
                {   
                    commonPackage.map(packageItem => {
                        return <PackageItem 
                                    key={packageItem.packageId} 
                                    data={packageItem}
                                    onClick={ this.selectPackage }
                                />;
                    })
                }               
                </div>
            </div>
        );
    }

    selectPackage(packageData, amount) {        
        this.props.selectPackageToBuy(packageData.packageId);
        if(auth.isAuthenticated()) {
            this.props.saveUserNewTransaction({packageData, amount, info: this.props.userData, config: this.props.config});            
        } else {            
            this.props.saveNewTransaction({packageData, amount, info: this.props.preUserData, form: this.props.registerForm, config: this.props.config});
        }
    }

	goBack() {
		this.props.history.goBack();
	}
}

const mapStateToProps = state => {
    return {
        config: state.paymentTransaction.config,
        registerForm: state.register.registerData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveNewTransaction(data) {
            dispatch(saveNewTransaction(data));
        },
        saveUserNewTransaction(data) {
            dispatch(saveUserNewTransaction(data));
        },
        selectPackageToBuy(data) {
            dispatch(selectPackageToBuy(data));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PackageItemContainer));